<template>
  <div class="tw-flex tw-items-center tw-justify-center">
    <div v-show="loading" class="tw-absolute tw-flex tw-items-center">
      <base-spinner :size="24" />
    </div>
    <button
      type="button"
      :class="[
        { 'tw-invisible': loading },
        value ? 'tw-bg-primary-500' : 'tw-bg-gray-200',
        'tw-relative tw-inline-flex tw-flex-shrink-0 tw-h-6 tw-w-11 tw-border-2 tw-border-transparent tw-rounded-full tw-cursor-pointer tw-transition tw-ease-in-out tw-duration-200 focus:tw-outline-none focus:tw-ring-2 focus:tw-ring-offset-2 focus:tw-ring-primary-500',
      ]"
      :disabled="disabled"
      role="switch"
      @click="$emit('input', !value)"
    >
      <span
        :class="[
          value ? 'tw-translate-x-5' : 'tw-translate-x-0',
          'tw-pointer-events-none tw-inline-block tw-h-5 tw-w-5 tw-rounded-full tw-bg-white tw-shadow tw-transform tw-ring-0 tw-transition tw-ease-in-out tw-duration-200',
        ]"
      />
    </button>
  </div>
</template>

<script>
export default {
  props: {
    value: Boolean,
    loading: Boolean,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
